import React, { useEffect, useState } from "react";
import styled from "styled-components";

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column; /* 세로 정렬 */
  align-items: center;
  justify-content: center;
  background-color: white; /* 배경색 */
  padding: 20px;
  text-align: center;
  font-size: 14px;
  height: 200px;
  font-family: "pretendard";

  white-space: pre-line;

  @media (max-width: 375px) {
    width: 375px;
    height: 150px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: pre-line;
  }
`;

const Title = styled.div`
  display: flex;
  margin-top: 50px;
  font-size: 16px;
  color: black;
  font-weight: bold;
  text-align: center;
  font-family: "pretendard";

  @media (max-width: 375px) {
    margin-top: 10px;
  }
`;

const TitleLight = styled.div`
  display: flex;
  margin-top: 10px;
  margin-bottom: 100px;
  font-size: 14px;
  color: black;
  text-align: center;
  font-family: "pretendard";

  @media (max-width: 375px) {
    margin-bottom: 0px;
    font-size: 12px;
  }
`;

const Footer = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 375);
    handleResize(); // 초기 화면 크기 체크
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <FooterWrapper>
      <Title marginTop="20px">SLIME INC.</Title>
      <TitleLight marginTop="20px">
        {isMobile
          ? `(주)슬라임 | 사업자등록번호. 358-81-03017 \n Tel. 010-7130-4374 \n3F 190, Sadang-ro, Dongjak-gu, Seoul, Republic of Korea`
          : `(주)슬라임 | 사업자등록번호. 358-81-03017 | Tel. 010-7130-4374 | 3F 190,
        Sadang-ro, Dongjak-gu, Seoul, Republic of Korea`}
      </TitleLight>
    </FooterWrapper>
  );
};

export default Footer;
